import React from "react";
import { Link } from "react-router-dom";
import { heroContent } from "../mock";
import { useModeContext } from "../contexts/ModeContext";

const AGB = () => {
  const { activeMode } = useModeContext();
  const c = heroContent.colors;

  return (
    <main className={`min-h-screen ${activeMode === 0 ? "bg-white" : "bg-neutral-950"}`}>
      {/* Header Spacer */}
      <div className="h-20"></div>
      
      <div className="mx-auto max-w-4xl px-6 py-12">
        <nav aria-label="Breadcrumb" className="mb-8">
          <ol className={`flex items-center space-x-2 text-sm ${activeMode === 0 ? "text-neutral-600" : "text-neutral-400"}`}>
            <li>
              <Link to="/" className={`hover:${activeMode === 0 ? "text-neutral-900" : "text-neutral-200"} transition-colors`}>
                Startseite
              </Link>
            </li>
            <li aria-hidden="true">/</li>
            <li aria-current="page" className={activeMode === 0 ? "text-neutral-900" : "text-neutral-200"}>AGB</li>
          </ol>
        </nav>

        <h1 className="text-3xl font-bold mb-8" style={{ color: c.heading }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className={`prose prose-neutral max-w-none ${activeMode === 1 ? "prose-invert" : ""}`}>
          <section aria-labelledby="geltungsbereich-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="geltungsbereich-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              1. Geltungsbereich
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge zwischen 
              Tom Oppenhäuser, Im Andorf 12, 56170 Bendorf (nachfolgend "Anbieter") und seinen Kunden 
              (nachfolgend "Kunde") über die Erbringung von Coaching-Dienstleistungen.
            </p>
            <p className="mb-6">
              Abweichende, entgegenstehende oder ergänzende allgemeine Geschäftsbedingungen des Kunden 
              werden nicht Vertragsbestandteil, es sei denn, ihrer Geltung wird ausdrücklich schriftlich 
              zugestimmt.
            </p>
          </section>

          <section aria-labelledby="vertragsschluss-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="vertragsschluss-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              2. Vertragsschluss
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Vertrag kommt durch die schriftliche Auftragsbestätigung des Anbieters oder durch die 
              Durchführung der ersten Coaching-Sitzung zustande.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Angebote des Anbieters sind freibleibend und unverbindlich. Ein Vertrag kommt erst durch 
              ausdrückliche Annahme des Auftrags durch den Anbieter zustande.
            </p>
          </section>

          <section aria-labelledby="leistungen-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : "bg-neutral-50"} p-4 rounded-lg mb-6`}>
            <h2 id="leistungen-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              3. Leistungen
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>3.1 Coaching-Dienstleistungen</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Anbieter erbringt Coaching-Dienstleistungen in den Bereichen Executive Coaching, 
              Einzelcoaching, Gruppencoaching und Keynote-Seminare. Die konkreten Leistungen werden im 
              jeweiligen Vertrag oder der Auftragsbestätigung festgelegt.
            </p>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>3.2 Kein Heilungsversprechen</h3>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Coaching ist keine psychotherapeutische oder medizinische Behandlung. Der Anbieter gibt keine 
              Heilungsversprechen ab und ersetzt keine ärztliche oder psychotherapeutische Behandlung.
            </p>
          </section>

          <section aria-labelledby="termine-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : "bg-neutral-50"} p-4 rounded-lg mb-6`}>
            <h2 id="termine-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              4. Termine und Durchführung
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>4.1 Terminvereinbarung</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Termine werden nach Absprache zwischen Anbieter und Kunde vereinbart. Der Kunde verpflichtet 
              sich, vereinbarte Termine einzuhalten.
            </p>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>4.2 Absagen und Verschiebungen</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Terminabsagen oder -verschiebungen durch den Kunden müssen mindestens 24 Stunden vor dem 
              vereinbarten Termin erfolgen. Bei kurzfristigeren Absagen wird die volle Sitzungsgebühr 
              in Rechnung gestellt.
            </p>
            <p className="mb-6">
              Der Anbieter behält sich vor, Termine aus wichtigen Gründen zu verschieben. In diesem Fall 
              wird ein Ersatztermin angeboten.
            </p>
          </section>

          <section aria-labelledby="vergütung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="vergütung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              5. Vergütung und Zahlungsbedingungen
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>5.1 Honorar</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Das Honorar richtet sich nach der jeweils gültigen Preisliste oder der individuellen 
              Vereinbarung. Alle Preise verstehen sich als Bruttopreise inklusive der gesetzlichen 
              Umsatzsteuer.
            </p>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>5.2 Zahlungsweise</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die Zahlung erfolgt nach Erhalt der Rechnung innerhalb von 14 Tagen ohne Abzug. Bei 
              Zahlungsverzug werden Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz 
              der Deutschen Bundesbank berechnet.
            </p>
            <p className="mb-6">
              Der Anbieter ist berechtigt, Vorauszahlungen zu verlangen oder die Leistungserbringung 
              von der Zahlung ausstehender Rechnungen abhängig zu machen.
            </p>
          </section>

          <section aria-labelledby="vertraulichkeit-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="vertraulichkeit-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              6. Vertraulichkeit und Datenschutz
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Anbieter verpflichtet sich zur Verschwiegenheit über alle ihm im Rahmen der Coaching-Tätigkeit 
              anvertrauten oder bekannt gewordenen Informationen. Diese Verschwiegenheitspflicht besteht auch 
              nach Beendigung des Vertragsverhältnisses fort.
            </p>
            <p className="mb-6">
              Die Verarbeitung personenbezogener Daten erfolgt entsprechend der Datenschutzerklärung und 
              den gesetzlichen Bestimmungen der DSGVO.
            </p>
          </section>

          <section aria-labelledby="pflichten-kunde-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="pflichten-kunde-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              7. Pflichten des Kunden
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Kunde verpflichtet sich zur aktiven Mitarbeit im Coaching-Prozess. Er stellt alle für 
              das Coaching relevanten Informationen wahrheitsgemäß zur Verfügung.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Kunde ist für die Umsetzung der im Coaching entwickelten Maßnahmen selbst verantwortlich. 
              Er trägt die Verantwortung für seine Entscheidungen und Handlungen.
            </p>
          </section>

          <section aria-labelledby="haftung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="haftung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              8. Haftung
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Anbieter haftet nur für Schäden, die vorsätzlich oder grob fahrlässig verursacht wurden. 
              Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht Schäden aus der 
              Verletzung des Lebens, des Körpers oder der Gesundheit oder aus der Verletzung wesentlicher 
              Vertragspflichten resultieren.
            </p>
            <p className="mb-6">
              Die Haftung für mittelbare Schäden, Folgeschäden und entgangenen Gewinn ist ausgeschlossen. 
              Die Haftungsbeschränkung gilt nicht für Ansprüche nach dem Produkthaftungsgesetz.
            </p>
          </section>

          <section aria-labelledby="kuendigung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="kuendigung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              9. Kündigung
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Beide Vertragsparteien können das Vertragsverhältnis jederzeit mit einer Frist von 
              zwei Wochen kündigen. Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die Kündigung bedarf der Schriftform. Bereits erbrachte Leistungen sind zu vergüten.
            </p>
          </section>

          <section aria-labelledby="widerrufsrecht-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="widerrufsrecht-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              10. Widerrufsrecht für Verbraucher
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Ist der Kunde Verbraucher (§ 13 BGB), steht ihm ein gesetzliches Widerrufsrecht zu:
            </p>
            <div className={`${activeMode === 1 ? "bg-neutral-800 text-neutral-200" : "bg-neutral-50"} p-4 rounded-lg mb-4`}>
              <h3 className={`font-semibold mb-2 ${activeMode === 1 ? "text-neutral-100" : ""}`}>Widerrufsbelehrung</h3>
              <p className={`mb-2 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
                <strong>Widerrufsrecht:</strong> Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von 
                Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag 
                des Vertragsschlusses.
              </p>
              <p className={`mb-2 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung 
                (z.B. ein mit der Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen 
                Vertrag zu widerrufen, informieren.
              </p>
              <p className={activeMode === 1 ? "text-neutral-300" : ""}>
                Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung 
                des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
              </p>
            </div>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Das Widerrufsrecht erlischt bei Dienstleistungsverträgen, wenn der Anbieter die Dienstleistung 
              vollständig erbracht hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem 
              der Verbraucher dazu seine ausdrückliche Zustimmung gegeben hat.
            </p>
          </section>

          <section aria-labelledby="schlussbestimmungen-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="schlussbestimmungen-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              11. Schlussbestimmungen
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>11.1 Anwendbares Recht</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Es gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts.
            </p>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>11.2 Gerichtsstand</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Gerichtsstand für alle Streitigkeiten aus diesem Vertragsverhältnis ist Bendorf, 
              sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder 
              öffentlich-rechtliches Sondervermögen ist.
            </p>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>11.3 Salvatorische Klausel</h3>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Sollten einzelne Bestimmungen dieser AGB unwirksam oder undurchführbar sein oder werden, 
              berührt dies nicht die Wirksamkeit der übrigen Bestimmungen. Die unwirksame Bestimmung 
              ist durch eine wirksame zu ersetzen, die dem wirtschaftlichen Zweck der unwirksamen 
              Bestimmung am nächsten kommt.
            </p>
          </section>

          <div className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : "bg-neutral-50"} p-4 rounded-lg mt-8`}>
            <p className={`text-sm ${activeMode === 1 ? "text-neutral-300" : "text-neutral-600"}`}>
              <strong>Stand:</strong> Januar 2024<br />
              Diese AGB können jederzeit eingesehen und ausgedruckt werden.
            </p>
          </div>
        </div>

        <div className={`mt-12 pt-8 border-t ${activeMode === 1 ? "border-neutral-800" : "border-neutral-200"}`}>
          <Link 
            to="/" 
            className={`inline-flex items-center ${activeMode === 1 ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-800"} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded`}
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </main>
  );
};

export default AGB;
